import AxiosInstance from 'src/shared/utils/AxiosSingleton';
import {
  AccountApiClient,
  ActionApiClient,
  AdminApiClient,
  AssetApiClient,
  AssistantApiClient,
  AssistantControlCenterApiClient,
  AttachmentApiClient,
  AttachmentClassificationApiClient,
  AuditLogApiClient,
  BadgeTemplateApiClient,
  BulletinApiClient,
  ClientApiClient,
  CloudWatchApiClient,
  ComplianceEventApiClient,
  ComplianceStandardApiClient,
  CourseAssignmentApiClient,
  CourseAssignmentRuleApiClient,
  CourseClassroomApiClient,
  CourseDefinitionApiClient,
  CourseSessionApiClient,
  CourseVideoApiClient,
  DepartmentApiClient,
  DeviceApiClient,
  DocumentApiClient,
  DocumentReviewApiClient,
  EquipmentTypeApiClient,
  FormApiClient,
  FormCategoryApiClient,
  FormDefinitionApiClient,
  GlobalAssistantControlCenterApiClient,
  InspectionApiClient,
  InspectionDispatchApiClient,
  InspectionScheduleApiClient,
  InspectionTypeApiClient,
  InstanceApiClient,
  InstanceComplianceStandardApiClient,
  InstanceSsoApiClient,
  IntegrationTokenAdminApiClient,
  ItemAssignmentApiClient,
  ItemDefinitionApiClient,
  JobApiClient,
  JobHazardAnalysisApiClient,
  KnowledgeBaseApiClient,
  LockApiClient,
  ModuleExtensionApiClient,
  NoteApiClient,
  NotificationApiClient,
  NotificationRuleApiClient,
  OshaApiClient,
  ProjectApiClient,
  PersonnelApiClient,
  RegionApiClient,
  ReportApiClient,
  ReportingComplianceApiClient,
  ReportInstanceApiClient,
  RiskAssessmentCodeApiClient,
  SafetyEventApiClient,
  SearchApiClient,
  SiteApiClient,
  SkillApiClient,
  SkillSignOffApiClient,
  UserActivityApiClient,
  TaskAssignmentApiClient,
  TaskDefinitionApiClient,
  UserApiClient,
  UserGroupApiClient,
  UserGroupPermissionApiClient,
  UserInstanceApiClient,
  VendorApiClient,
  VendorSignupApiClient,
  WorkflowApiClient,
  WorkflowDefinitionApiClient,
  WorkflowNexusApiClient,
} from './ProactApiClient';

const urlDirty = import.meta.env.VITE_API;
const url = urlDirty?.substring(0, urlDirty.length - 1);

export const reportingComplianceApiClient = new ReportingComplianceApiClient(
  url,
  AxiosInstance
);

export const assetApiClient = new AssetApiClient(url, AxiosInstance);
export const backgroundJobClient = new JobApiClient(url, AxiosInstance);
export const cloudWatchClient = new CloudWatchApiClient(url, AxiosInstance);
export const complianceEventApiClient = new ComplianceEventApiClient(
  url,
  AxiosInstance
);
export const complianceStandardApiClient = new ComplianceStandardApiClient(
  url,
  AxiosInstance
);
export const departmentApiClient = new DepartmentApiClient(url, AxiosInstance);
export const instanceComplianceStandardApiClient =
  new InstanceComplianceStandardApiClient(url, AxiosInstance);
export const instanceApiClient = new InstanceApiClient(url, AxiosInstance);
export const instanceSsoApiClient = new InstanceSsoApiClient(
  url,
  AxiosInstance
);
export const accountApiClient = new AccountApiClient(url, AxiosInstance);
export const userApiClient = new UserApiClient(url, AxiosInstance);
export const formApiClient = new FormApiClient(url, AxiosInstance);
export const formDefinitionApiClient = new FormDefinitionApiClient(
  url,
  AxiosInstance
);
export const formCategoryApiClient = new FormCategoryApiClient(
  url,
  AxiosInstance
);
export const taskDefinitionApiClient = new TaskDefinitionApiClient(
  url,
  AxiosInstance
);
export const taskAssignmentApiClient = new TaskAssignmentApiClient(
  url,
  AxiosInstance
);

export const actionApiClient = new ActionApiClient(url, AxiosInstance);
export const adminApiClient = new AdminApiClient(url, AxiosInstance);
export const workflowApiClient = new WorkflowApiClient(url, AxiosInstance);
export const workflowDefinitionApiClient = new WorkflowDefinitionApiClient(
  url,
  AxiosInstance
);
export const workflowNexusApiClient = new WorkflowNexusApiClient(
  url,
  AxiosInstance
);

export const personnelApiClient = new PersonnelApiClient(url, AxiosInstance);

export const documentApiClient = new DocumentApiClient(url, AxiosInstance);
export const documentReviewApiClient = new DocumentReviewApiClient(
  url,
  AxiosInstance
);

export const safetyEventApiClient = new SafetyEventApiClient(
  url,
  AxiosInstance
);

export const vendorApiClient = new VendorApiClient(url, AxiosInstance);
export const vendorSignupApiClient = new VendorSignupApiClient(
  url,
  AxiosInstance
);

export const clientApiClient = new ClientApiClient(url, AxiosInstance);
export const siteApiClient = new SiteApiClient(url, AxiosInstance);
export const deviceApiClient = new DeviceApiClient(url, AxiosInstance);
export const equipmentTypeApiClient = new EquipmentTypeApiClient(
  url,
  AxiosInstance
);
export const inspectionTypeApiClient = new InspectionTypeApiClient(
  url,
  AxiosInstance
);
export const inspectionApiClient = new InspectionApiClient(url, AxiosInstance);
export const inspectionScheduleApiClient = new InspectionScheduleApiClient(
  url,
  AxiosInstance
);
export const inspectionDispatchApiClient = new InspectionDispatchApiClient(
  url,
  AxiosInstance
);

export const courseDefinitionApiClient = new CourseDefinitionApiClient(
  url,
  AxiosInstance
);
export const courseSessionApiClient = new CourseSessionApiClient(
  url,
  AxiosInstance
);
export const courseAssignmentApiClient = new CourseAssignmentApiClient(
  url,
  AxiosInstance
);
export const courseClassroomApiClient = new CourseClassroomApiClient(
  url,
  AxiosInstance
);
export const courseAssignmentRuleApiClient = new CourseAssignmentRuleApiClient(
  url,
  AxiosInstance
);
export const courseVideoApiClient = new CourseVideoApiClient(
  url,
  AxiosInstance
);
export const skillApiClient = new SkillApiClient(url, AxiosInstance);
export const skillSignOffApiClient = new SkillSignOffApiClient(
  url,
  AxiosInstance
);
export const userGroupApiClient = new UserGroupApiClient(url, AxiosInstance);
export const userGroupPermissionsApiClient = new UserGroupPermissionApiClient(
  url,
  AxiosInstance
);

export const notificationRuleApiClient = new NotificationRuleApiClient(
  url,
  AxiosInstance
);

export const itemDefinitionApiClient = new ItemDefinitionApiClient(
  url,
  AxiosInstance
);
export const itemAssignmentApiClient = new ItemAssignmentApiClient(
  url,
  AxiosInstance
);
export const userInstanceApiClient = new UserInstanceApiClient(
  url,
  AxiosInstance
);

export const reportInstanceApiClient = new ReportInstanceApiClient(
  url,
  AxiosInstance
);
export const riskAssessmentCodeApiClient = new RiskAssessmentCodeApiClient(
  url,
  AxiosInstance
);
export const jobHazardAnalysisApiClient = new JobHazardAnalysisApiClient(
  url,
  AxiosInstance
);
export const noteApiClient = new NoteApiClient(url, AxiosInstance);
export const attachmentApiClient = new AttachmentApiClient(url, AxiosInstance);
export const notificationApiClient = new NotificationApiClient(
  url,
  AxiosInstance
);
export const lockApiClient = new LockApiClient(url, AxiosInstance);

export const auditLogApiClient = new AuditLogApiClient(url, AxiosInstance);
export const reportApiClient = new ReportApiClient(url, AxiosInstance);
export const bulletinApiClient = new BulletinApiClient(url, AxiosInstance);
export const moduleExtensionApiClient = new ModuleExtensionApiClient(
  url,
  AxiosInstance
);
export const projectApiClient = new ProjectApiClient(url, AxiosInstance);
export const regionApiClient = new RegionApiClient(url, AxiosInstance);
export const oshaApiClient = new OshaApiClient(url, AxiosInstance);
export const attachmentClassificationApiClient =
  new AttachmentClassificationApiClient(url, AxiosInstance);
export const integrationTokenAdminApiClient =
  new IntegrationTokenAdminApiClient(url, AxiosInstance);
export const userActivityApiClient = new UserActivityApiClient(
  url,
  AxiosInstance
);
export const searchApiClient = new SearchApiClient(url, AxiosInstance);
export const badgeTemplateApiClient = new BadgeTemplateApiClient(
  url,
  AxiosInstance
);
export const knowledgeBaseApiClient = new KnowledgeBaseApiClient(
  url,
  AxiosInstance
);
export const assistantApiClient = new AssistantApiClient(url, AxiosInstance);
export const assistantControlCenterApiClient =
  new AssistantControlCenterApiClient(url, AxiosInstance);
export const globalAssistantControlCenterApiClient =
  new GlobalAssistantControlCenterApiClient(url, AxiosInstance);
